"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeImportOpenApiOut = void 0;
class EventTypeImportOpenApiOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EventTypeImportOpenApiOut.attributeTypeMap;
    }
}
exports.EventTypeImportOpenApiOut = EventTypeImportOpenApiOut;
EventTypeImportOpenApiOut.discriminator = undefined;
EventTypeImportOpenApiOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "EventTypeImportOpenApiOutData",
        "format": ""
    }
];
//# sourceMappingURL=EventTypeImportOpenApiOut.js.map